<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100">
  <div class="row">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3>{{ translationService.getTranslation('Daily Activities') }}</h3>
      <h5>{{ translationService.getTranslation('Branch') }}: {{ userBranchName }}</h5>
    </div>
    <hr>
    <div class="row g-4">
      <div class="col-3" *ngFor="let widget of widgets" (click)="selectWidget(widget)" data-bs-toggle="modal" data-bs-target="#widgetModal">
        <div class="card shadow-sm border-0 btn bg-light">
          <div class="card-body text-center">
            <h5 class="card-title text-muted">{{ translationService.getTranslation(widget.title) }}</h5>
            <h1 class="display-2" [ngClass]="widget.colorClass">{{ widget.count }}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <h3>{{ translationService.getTranslation('Daily Statistics View') }}</h3>
    <hr>

    <div class="col-3">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <h5 class="card-title">{{ translationService.getTranslation('Examinees by Course') }}</h5>
          <canvas id="testResultsChart"></canvas>
        </div>
      </div>
    </div>

    <div class="col-3">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <h5 class="card-title">{{ translationService.getTranslation('Result Distribution') }}</h5>
          <canvas id="totalPassAndNotPass"></canvas>
        </div>
      </div>
    </div>
  </div> 
  </div> 

  <div class="modal fade" id="widgetModal" tabindex="-1" aria-labelledby="widgetModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content border-0 shadow">
        <div class="modal-header">
          <h5 class="modal-title mx-3" id="widgetModalLabel" >
            {{ selectedWidget?.title ? translationService.getTranslation(selectedWidget.title) : '' }}
          </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

          <div class="d-flex flex-column gap-2 py-2">
            <div class="d-flex gap-3 flex-wrap">
              <div style="min-width: 220px;">
                <label class="form-label mb-1">{{ translationService.getTranslation('Select Course') }}:</label>
                <select class="form-control" [(ngModel)]="selectedCourseFilter">
                  <option value="">{{ translationService.getTranslation('All Courses') }}</option>
                  <option *ngFor="let course of uniqueCourses" [value]="course">
                    {{ course }}
                  </option>
                </select>
              </div>

              <div style="min-width: 200px;">
                <label class="form-label mb-1">{{ translationService.getTranslation('Select Language') }}:</label>
                <select class="form-control" [(ngModel)]="selectedLangFilter">
                  <option value="">{{ translationService.getTranslation('All Languages') }}</option>
                  <option *ngFor="let lang of uniqueLanguages" [value]="lang">
                    {{ lang }}
                  </option>
                </select>
              </div>

              <div *ngIf="selectedWidget?.title == 'Upcoming Exam Candidates'">
                <label class="form-label mb-1">{{ translationService.getTranslation('From Date') }}:</label>
                <input type="date" class="form-control" [(ngModel)]="fromDate" [min]="minDate">
              </div>

              <div *ngIf="selectedWidget?.title == 'Upcoming Exam Candidates'">
                <label class="form-label mb-1">{{ translationService.getTranslation('To Date') }}:</label>
                <input type="date" class="form-control" [(ngModel)]="toDate" [min]="minDate">
              </div>

              <div class="d-flex align-items-end" style="min-width: 150px;">
                <button [disabled]="totalStudents < 1" class="btn btn-success w-100 mt-auto" (click)="exportToExcel()">
                  {{ translationService.getTranslation('Export') }}
                </button>
              </div>

            </div>
          </div>
          
          <div *ngIf="selectedWidget?.title == 'Candidates for Today'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Exam Date') }}</th>
                  <th>{{ translationService.getTranslation('Session Time') }}</th>
                </tr>                
              </thead>
              <tbody>
                <tr *ngFor="let student of filteredCandidateForToday">
                  <td>{{ student.id }}</td>
                  <td>{{ student.name }}</td>
                  <td>{{ student.phone }}</td>
                  <td>{{ student.courseName }}</td>
                  <td>{{ student.language }}</td>
                  <td>{{ student.bookType }}</td>
                  <td>{{ student.gender }}</td>
                  <td>{{ student.examDate | date:'MM/dd/yyyy' }}</td>
                  <td>{{ student.sessionTime }}</td>
                </tr>                               
              </tbody>
            </table>
          </div>  
                      
          <div *ngIf="selectedWidget?.title == 'Candidates Currently Testing'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Start Exam') }}</th>
                  <th>{{ translationService.getTranslation('Status') }}</th>
                </tr>                
              </thead>
              <tbody>
                <tr *ngFor="let student of filteredCandidatesCurrentlyTesting">
                  <td>{{ student.IDNumber }}</td>
                  <td>{{ student.ExamAttendanceNo }}</td>
                  <td>{{ student.TraineeName }}</td>
                  <td>{{ student.PhoneNumber }}</td>
                  <td>{{ student.Gender }}</td>
                  <td>{{ student.BookingType }}</td>
                  <td>{{ student.CourseName }}</td>
                  <td>{{ student.LanguageName }}</td>
                  <td>{{ student.StartExamDate | date:'HH:mm' }}</td>
                  <td>{{ student.ExamResult }}</td>
                </tr>                               
              </tbody>
            </table>
          </div>

          <div *ngIf="selectedWidget?.title == 'Completed Exams Today'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Marks') }}</th>
                  <th>{{ translationService.getTranslation('Result') }}</th>
                </tr>                
              </thead>
              <tbody>
                <tr *ngFor="let student of filteredCompletedExamsToday">
                  <td>{{ student.IDNumber }}</td>
                  <td>{{ student.ExamAttendanceNo }}</td>
                  <td>{{ student.TraineeName }}</td>
                  <td>{{ student.PhoneNumber }}</td>
                  <td>{{ student.CourseName }}</td>
                  <td>{{ student.LanguageName }}</td>
                  <td>{{ student.Gender }}</td>
                  <td>{{ student.BookingType }}</td>
                  <td>{{ student.Marks }}</td>
                  <td>{{ student.ExamResult }}</td>
                </tr>                               
              </tbody>
            </table>
          </div>

          <div *ngIf="selectedWidget?.title == 'Upcoming Exam Candidates'" class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Exam Date') }}</th>
                  <th>{{ translationService.getTranslation('Session Time') }}</th>
                </tr>                
              </thead>
              <tbody>
                <tr *ngFor="let student of filteredUpcomingExamCandidates">
                  <td>{{ student.id }}</td>
                  <td>{{ student.name }}</td>
                  <td>{{ student.phone }}</td>
                  <td>{{ student.courseName }}</td>
                  <td>{{ student.language }}</td>
                  <td>{{ student.bookType }}</td>
                  <td>{{ student.gender }}</td>
                  <td>{{ student.examDate | date:'MM/dd/yyyy' }}</td>
                  <td>{{ student.sessionTime }}</td>
                </tr>                               
              </tbody>
            </table>
          </div>      
          <div class="pt-2">
            <p>{{ translationService.getTranslation('Total Candidates') }}: {{totalStudents}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
